import { Gift } from "lucide-react";
import { WishlistView } from "@/components/WishlistView";

export default function WishlistPage() {
  return (
    <div className="iks-fade-up">
      <div className="flex items-center gap-3 mb-5">
        <div className="w-10 h-10 rounded-xl bg-sky-500/10 flex items-center justify-center">
          <Gift size={20} className="text-sky-400" />
        </div>
        <div>
          <h1 className="font-display font-bold text-2xl text-slate-50">My WishList</h1>
          <p className="text-slate-400 text-sm">Things you'd love to receive.</p>
        </div>
      </div>
      <WishlistView />
    </div>
  );
}
